import { Reactivation } from './scenes/Reactivation';

export const ReactivationPage = Reactivation;